export default {
    methods: {
        formatUSD(number) {
            if (!number || isNaN(number)) {
                return '$0.00';
            }
            return `${number.toLocaleString('en-US', {style: 'currency', currency: 'USD'})}`;
        },
        formatDatForQuery(date) {
            let year = date.getFullYear();
            let month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
            let day = String(date.getDate()).padStart(2, '0');
            let hours = String(date.getHours()).padStart(2, '0');
            let minutes = String(date.getMinutes()).padStart(2, '0');
            let seconds = String(date.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        formatDate(date) {
            if (date instanceof(Date))
            {
                const day = date.getDate();
                return `${day}`;
            }
        },
        formatDateYYYYMMDD(date) {
            if (date instanceof Date) {
                return new Intl.DateTimeFormat('en-CA', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                }).format(date);
            }
            return null;
        },
        formatHeaderDate(dateStr) {
            if (typeof dateStr === 'string') {
                const [year, month, day] = dateStr.split('-');
                return Number(day);
            }
            return null;
        },
        getMonthDates(month) {
            let dates = [];
            if (month instanceof Date) {
                month = this.formatMonth(month);
            };
            let [monthPart, yearPart] = month.split('/');
            let currentYear = parseInt(yearPart); // Assuming yearPart is in YY format
            let currentDate = new Date(currentYear, parseInt(monthPart) - 1, 1);
            let today = new Date();

            // Get the last day of the month
            let lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();

            // Loop through all days of the month
            for (let day = 1; day <= lastDay; day++) {
                let date = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
                if (
                    date.getFullYear() < today.getFullYear() ||
                    (date.getFullYear() === today.getFullYear() && date.getMonth() < today.getMonth()) ||
                    (date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() && date.getDate() <= today.getDate())
                ) {
                    dates.push(date);
                }
            }

            return dates;
        },
        clearTable(tableArray) {
            tableArray.forEach(row => {
                row.amount = 0;
            });
        },
    }
}